import React from 'react';
import TutorialWelcomeModal from './TutorialWelcomeModal';
import TutorialOverlay from './TutorialOverlay';

export { TutorialProvider, useTutorial } from './TutorialContext';

export default function Tutorial() {
  return (
    <div className="tutorial-component">
      <TutorialWelcomeModal />
      <TutorialOverlay />
    </div>
  );
}
